export default {
  START_TRACK: 'START_TRACK',
  PAUSE_TRACK: 'PAUSE_TRACK',
  RESUME_TRACK: 'RESUME_TRACK',
  START_PLAYLIST: 'START_PLAYLIST',
  ADD_TO_QUEUE: 'ADD_TO_QUEUE',
  NEXT_TRACK: 'NEXT_TRACK',
  PREVIOUS_TRACK: 'PREVIOUS_TRACK',
  UPDATE_PLAYER_PROGRESS: 'UPDATE_PLAYER_PROGRESS'
}



// WEBPACK FOOTER //
// ./src/Player/actionTypes.js